import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import { Done } from '@material-ui/icons';
import { useCheckTenantNotification, useGetTenantNotification } from './hooks';

const useStyles = makeStyles({
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    zIndex: 1000,
  },
});

const TenantNotificationDialog = () => {
  const { opened, data, handleCloseModal, loading: getTenantNotificationLoading } = useGetTenantNotification();

  const { checkNotification, loading: checkNotificationLoading } = useCheckTenantNotification(handleCloseModal);

  // Styles
  const classes = useStyles();

  return (
    <Dialog open={opened} fullWidth maxWidth="sm" scroll="body">
      {getTenantNotificationLoading && (
        <Box className={classes.loader}>
          <CircularProgress />
        </Box>
      )}

      <DialogTitle>
        <b>Уведомление для арендатора</b>
      </DialogTitle>

      {data && (
        <>
          <DialogContent dividers>
            <DialogContentText>{data.notification.message}</DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              disabled={checkNotificationLoading}
              startIcon={<Done />}
              onClick={() => checkNotification(data.notificationId)}
            >
              Осведомлен(-а)
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default TenantNotificationDialog;
